import { createContext, FC, useEffect, useState } from "react";
import PrescriptionList from "./PrescriptionList";
import ButtonsContainer from "./ButtonsContainer";
import { PrescriptionContextType, PrescriptionType } from "./types";
export const PrescriptionContext = createContext<PrescriptionContextType>({
  list:[],
  setList:()=>{},
  edit:null,
  setEdit:()=>{}
})
const PatientPrescription:FC = ()=>{
    const [list,setList] = useState<PrescriptionType[]>([])
    const [edit,setEdit] = useState<PrescriptionType | null>(null)
useEffect(()=>{
  return ()=>{
   setEdit(null)
   setList([])
  }
},[])
   return (
   <PrescriptionContext.Provider value={{list,setList,edit,setEdit}}>
      <ButtonsContainer/>
      <PrescriptionList/>
   </PrescriptionContext.Provider>
   )
}

export default PatientPrescription